import * as types from "./actionTypes"

export function fetchUserViewDetails() {
    return {
        type: types.USER_VIEWS_DETAILS_FETCH,
    }
}

export function fetchUserViewDetailsSuccess(data) {
    return {
        type: types.USER_VIEWS_DETAILS_FETCH_SUCCESS,
        payload: data,
    }
}

export function saveUserViewDetails(data) {
    return {
        type: types.USER_VIEWS_SAVE,
        payload: data,
    }
}

export function saveUserViewDetailsSuccess(data) {
    return {
        type: types.USER_VIEWS_SAVE_SUCCESS,
        payload: data,
    }
}

export function updateUserViewDetails(data, isManageViewModal = false) {
    return {
        type: types.USER_VIEWS_UPDATE,
        payload: data,
        isManageViewModal,
    }
}

export function updateUserViewDetailsSuccess(data) {
    return {
        type: types.USER_VIEWS_UPDATE_SUCCESS,
        payload: data,
    }
}

export function deleteUserViewDetails(data) {
    return {
        type: types.USER_VIEWS_DELETE,
        payload: data,
    }
}

export function deleteUserViewDetailsSuccess(data) {
    return {
        type: types.USER_VIEWS_DELETE_SUCCESS,
        payload: data,
    }
}

export function createOrUpdateStatus(status) {
    return {
        type: types.USER_VIEW_CREATED_OR_UPDATED_RECENTLY,
        payload: status,
    }
}

export function userViewClearAll() {
    return {
        type: types.USER_VIEW_CLEAR_ALL,
    }
}
export function toggleViewMangerNotification(notification = {}) {
    return {
        type: types.TOGGLE_VIEW_MANAGER_NOTIFICATION,
        payload: notification,
    }
}
